import { type RouteLocationNormalizedGeneric } from 'vue-router';

import { UserGroup } from '@/types';

interface RouteMeta {
  authorizedGroups?: UserGroup[];
}

export function isPrivateRoute(targetRoute: RouteLocationNormalizedGeneric): boolean {
  const meta = targetRoute.meta as RouteMeta;
  return !!(meta?.authorizedGroups && meta?.authorizedGroups.length > 0);
}

export function isUserAuthorizedForRoute(
  userGroups: UserGroup[],
  targetRoute: RouteLocationNormalizedGeneric,
): boolean {
  const meta = targetRoute.meta as RouteMeta;
  if (!meta || !meta.authorizedGroups) {
    return true;
  }
  return meta.authorizedGroups.some((authorizedGroup: UserGroup) =>
    userGroups.includes(authorizedGroup),
  );
}
